import Repository from "./repository"

export default {
  /**
   * パスワードリセット登録
   * @params  パラメータ
   * @returns response
   */
  add(params) {
    return Repository.post("/api/s208-password-reset/add", params);
  },
  /**
   * パスワードリセットチェック
   * @params パラメータ
   * @returns response
   */
  check(params) {
    return Repository.get("/api/s208-password-reset/check?token=" + params);
  },
  /**
   * パスワードリセット実行
   * @params  パラメータ
   * @returns response
   */
  edit(params) {
    return Repository.post("/api/s208-password-reset/edit", params)
  }
}